export enum OffersNav {
  OFFERS = 'offers'
}
